<template>
  <Popover class="relative">
    <PopoverButton class="w-full" :disabled="!receiptsExist">
      <div class="download-button-table">
        <button
          class="download-button-table
          text-purple
          border-4 border-purple
          rounded-full
          w-full
          h-10
          hover:text-white hover:bg-purple
          disabled:opacity-50"
          :class="`border-${color}`"
          style="width:100%;"
          :disabled="!receiptsExist"
        >
          <div class="flex flex-row items-center justify-center">
            <download-icn
              width="20px"
              height="20px"
              class="mr-1 purple-icon hover-white-icon"
            ></download-icn>
            <span class="font-bold text-lg">領収書</span>
            <receipt-icn
              width="20px"
              height="20px"
              class="ml-1 hover-white-icon"
              fill-rule="evenodd"
              fill="#A068E0"
            ></receipt-icn>
          </div>
        </button>
      </div>
    </PopoverButton>
    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
    >
      <PopoverPanel
        class="w-full border bg-white px-1 py-1 mt-1 absolute z-10"
        style="border-radius: 20px; width:260px;"
        :class="`border-${color}`"
      >
        <span class="text-purple ml-5">貼付用紙を出力する月を選択 </span>
        <table
          class="flex flex-row items-center border border-l-0 border-r-0  border-b-0 border-purple "
        >
          <tbody>
            <tr v-for="rowIndex in Math.ceil(Month.length / 3)" :key="rowIndex">
              <td v-for="index in 3" :key="`td-${index}`">
                <PopoverButton>
                  <button
                    type="button"
                    v-if="Month[index - 1 + (rowIndex - 1) * 3]"
                    :class="
                      `h-7 w-20 text-left pl-7 text-${color} font-bold hover:text-white hover:bg-${color}`
                    "
                    style="border-radius: 20px;"
                    @click="
                      MonthDownload(Month[index - 1 + (rowIndex - 1) * 3])
                    "
                  >
                    <div class="flex flex-row items-center">
                      <template
                        v-if="Month[index - 1 + (rowIndex - 1) * 3].iconUrl"
                        ><img
                          :src="
                            require('../../assets/' +
                              Month[index - 1 + (rowIndex - 1) * 3].iconUrl)
                          "
                          class="mr-1"
                          width="20"
                          height="20"
                        />
                      </template>
                      {{ Month[index - 1 + (rowIndex - 1) * 3].name }}
                    </div>
                  </button>
                </PopoverButton>
              </td>
            </tr>
          </tbody>
        </table>
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { useDownloads } from '@/services/useDownloads'
import DownloadIcn from '@/assets/icons/download.svg?inline'
import ReceiptIcn from '@/assets/icons/receipt.svg?inline'

import { reactive } from 'vue'

export default {
  name: 'AppDownloadMonthBtn',

  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
    DownloadIcn,
    ReceiptIcn,
  },
  props: {
    color: {
      type: String,
      default: '',
    },
    year: {
      type: String,
      default: '',
    },
    receiptsExist: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    let result = reactive([])
    const Month = [
      {
        name: '1月',
      },
      {
        name: '2月',
      },
      {
        name: '3月',
      },
      {
        name: '4月',
      },
      {
        name: '5月',
      },
      {
        name: '6月',
      },
      {
        name: '7月',
      },
      {
        name: '8月',
      },
      {
        name: '9月',
      },
      {
        name: '10月',
      },
      {
        name: '11月',
      },
      {
        name: '12月',
      },
    ]

    const display = () => result.map(item => item.name).join(', ')
    const { downloadExcel } = useDownloads()
    const MonthDownload = item => {
      if (
        item.name.slice(0, -1) == 1 ||
        item.name.slice(0, -1) == 2 ||
        item.name.slice(0, -1) == 3
      ) {
        downloadExcel(Number(props.year) + 1, item.name.slice(0, -1))
      } else {
        downloadExcel(props.year, item.name.slice(0, -1))
      }
    }
    return { MonthDownload, display, result, Month }
  },
}
</script>

<style lang="scss" scoped>
#headlessui-popover-panel-4 {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
.download-button-table {
  width: 100%;
  :disabled {
    pointer-events: none;
  }
}
.download-button-table :hover svg.hover-white-icon {
  path {
    fill: #fff;
  }
}
button[disabled] {
  pointer-events: none;
}
</style>
